import {
  Box,
  Button,
  ButtonProps,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useBreakpoint from "../../hooks/useBreakpoint";
import CloseIcon from "@mui/icons-material/Close";

interface QRDialogProps {
  srcFunction: () => Promise<string | undefined>;
  buttonProps?: ButtonProps;
  disabled?: boolean;
}

export default function QRButton(props: QRDialogProps) {
  const { t } = useTranslation("QRButton");
  const breakpoint = useBreakpoint();
  const [open, setOpen] = useState(false);
  const [src, setSrc] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const loadQR = async () => {
    const data = await props.srcFunction();
    if (typeof data === "string") setSrc(data);
  };

  useEffect(() => {
    if (open) loadQR();
    else setSrc("");
  }, [open]);

  return (
    <>
      <Button
        disabled={props.disabled}
        onClick={() => setOpen(true)}
        {...props.buttonProps}
        variant={breakpoint.sm ? "outlined" : "text"}
        startIcon={<QrCodeScannerIcon />}
        color="warning"
      >
        {breakpoint.sm && t("ViewQrCode")}
      </Button>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Stack direction={"row"} spacing={"auto"}>
            <Typography variant="h4" gutterBottom>
              {t("QR")}
            </Typography>

            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{t("PleaseScan")}</DialogContentText>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            pt={4}
          >
            {src ? <img src={src} /> : <CircularProgress />}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
